import React from 'react';
import { useInvestorScope } from '../../store/selectors';
import { AboutThisPage } from '../../ui/primitives';
import { InvestorTitle, SectionLabel } from '../common';
import TaskList from './TaskList';

export default function TasksPage() {
  const scope = useInvestorScope();
  const open = scope.tasks
    .filter((task) => task.status === 'OPEN')
    .sort((a, b) => (a.dueDate ?? '9999').localeCompare(b.dueDate ?? '9999'));
  const done = scope.tasks.filter((task) => task.status === 'DONE');
  return (
    <>
      <InvestorTitle
        title="Tasks"
        subtitle="Everything we need from you, across all your entities."
      />
      <AboutThisPage>
        <p>
          Tasks are created by the registry automatically — for example when a capital call is
          issued, a certificate is about to expire, or a TFN is missing. Completing them here
          updates your records immediately.
        </p>
      </AboutThisPage>
      <TaskList tasks={open} />
      {done.length > 0 && (
        <>
          <SectionLabel>Completed</SectionLabel>
          <TaskList tasks={done} compact />
        </>
      )}
    </>
  );
}
